import { render, staticRenderFns } from "./TaskMeasurement.vue?vue&type=template&id=006f08f2&lang=pug"
import script from "./TaskMeasurement.vue?vue&type=script&lang=js"
export * from "./TaskMeasurement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports